import { RoleEnum } from "./role-enum";

export enum RouteName {
  DASHBOARD = 'DASHBOARD',
  MANAGEMENT = 'MANAGEMENT',
  ALLOCATION = 'ALLOCATION',
  PRODUCTS = 'PRODUCTS',
  ANALYTICS = 'ANALYTICS',
  FINANCE = 'FINANCE',
}

export type Route = {
  label: string,
  icon: string,
  icon_selected: string,
  path: string,
  authorizedRoles: RoleEnum[],
}

export const ROUTES: Route[] = [
  {
    label: "PAGES.DASHBOARD.TITLE",
    icon: "./assets/images/dashboard.svg",
    icon_selected: "./assets/images/dashboard_w.svg",
    path: "/home/dashboard",
    authorizedRoles: [RoleEnum.ADMIN, RoleEnum.LOGISTIC, RoleEnum.LOGISTIC_READONLY, RoleEnum.WELCOME]
  },
  {
    label: "PAGES.MANAGEMENT.TITLE",
    icon: "./assets/images/management.svg",
    icon_selected: "./assets/images/management_w.svg",
    path: "/home/management",
    authorizedRoles: [RoleEnum.ADMIN, RoleEnum.WELCOME]
  },
  {
    label: "PAGES.ALLOCATION.TITLE",
    icon: "./assets/images/allocation.svg",
    icon_selected: "./assets/images/allocation_w.svg",
    path: "/home/allocation",
    authorizedRoles: [RoleEnum.ADMIN, RoleEnum.LOGISTIC, RoleEnum.LOGISTIC_READONLY]
  },
  {
    label: "PAGES.PRODUCTS.TITLE",
    icon: "./assets/images/products.svg",
    icon_selected: "./assets/images/products_w.svg",
    path: "/home/products",
    authorizedRoles: [RoleEnum.ADMIN, RoleEnum.LOGISTIC, RoleEnum.LOGISTIC_READONLY]
  },
  {
    label: "PAGES.ANALYTICS.TITLE",
    icon: "./assets/images/analytics.svg",
    icon_selected: "./assets/images/analytics_w.svg",
    path: "/home/analytics",
    authorizedRoles: [RoleEnum.ADMIN]
  },
  {
    label: "PAGES.FINANCE.TITLE",
    icon: "./assets/images/finance.svg",
    icon_selected: "./assets/images/finance_w.svg",
    path: "/home/finance",
    authorizedRoles: [RoleEnum.ADMIN, RoleEnum.FINANCE]
  }
]
